import React from 'react';
import { Box, useTheme } from '@mui/system';
import FavouriteDashboards from 'routes/Home/components/FavouriteDashboards/FavouriteDashboards';
import RecentlyViewedDashboards from 'routes/Home/components/ViewedDashboards/ViewedDashboards';
import HighlightBox from 'components/SharedComponents/HighlightContainer/HighlightBox';
import { useTranslation } from 'react-i18next';
import { DashboardFolderT, DashboardT } from 'business/definitions';
import { useDashboardSearchAndFolders } from '../../hooks/useDashboardSearchAndFolders';
import DashboardsGrid from 'routes/AllDashboards/components/DashboardsGrid/DashboardsGrid';
import DashboardsTabHeader from '../Header/DashboardsTabHeader';

type Props = {
    dashboardFolders: DashboardFolderT[];
    dashboards: DashboardT[];
};

const DashboardsHome = ({ dashboardFolders, dashboards }: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const {
        isSearching,
        setSearchValue,
        currentFolder,
        handleFolder,
        displayedDashboards,
        displayedDashboardFolders,
    } = useDashboardSearchAndFolders(dashboardFolders, dashboards);

    return (
        <>
            <Box
                id="pendo-first-steps-box"
                sx={{ marginX: theme.spacing(2) }}
            ></Box>

            <DashboardsTabHeader
                resetTrigger={!isSearching}
                setSearchValue={setSearchValue}
                showArchivedDashboardsButton
            />
            {isSearching || !!currentFolder ? (
                <DashboardsGrid
                    folders={displayedDashboardFolders}
                    dashboards={displayedDashboards}
                    isSearching={isSearching}
                    currentFolder={currentFolder}
                    handleFolder={handleFolder}
                />
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        gap: 2,
                        margin: theme.spacing(2),
                        marginTop: 0,
                        flexGrow: 1,
                    }}
                >
                    <HighlightBox sx={{ flex: 1 }}>
                        <RecentlyViewedDashboards
                            title={t('dashboards.recentlyViewed')}
                        />
                    </HighlightBox>
                    <HighlightBox sx={{ flex: 1 }}>
                        <FavouriteDashboards
                            title={t('dashboards.favourites')}
                            disableShowMore
                        />
                    </HighlightBox>
                </Box>
            )}
        </>
    );
};

export default DashboardsHome;
